import * as React from "react";
import ChartSoldeFinancier from "./ChartSoldeFinancier";
import ChartNiveauVie from "./ChartNiveauVie";
import ChartTempsRetraite from "./ChartTempsRetraite";
import ReglageParametres from "./ReglageParametres";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import calculerSoldeTouteAnnee from "../libs/calculerSoldeTouteAnnee.js";
import Filter1OutlinedIcon from "@mui/icons-material/Filter1Outlined";
import Filter2OutlinedIcon from "@mui/icons-material/Filter2Outlined";
import Filter3OutlinedIcon from "@mui/icons-material/Filter3Outlined";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import PhraseCourbeRouge from "./PhraseCourbeRouge";

const steps = [
  "L'équilibre financier",
  "Le niveau de vie des retraités",
  "La durée de la retraite",
];

function ContenuEtape(props) {
  return (
    <React.Fragment>
      <Box paddingBottom="20px">
      <Typography level="h2" fontSize="26px">
        <Typography color="primary" level="h2" fontSize="23px">
          {props.activeStep === 0 ? (
            <Filter1OutlinedIcon />
          ) : props.activeStep === 1 ? (
            <Filter2OutlinedIcon />
          ) : (
            <Filter3OutlinedIcon />
          )}{" "}
          Étape {props.activeStep + 1} :
        </Typography>
        {props._activeStep}
      </Typography>
      <Typography>
        {props.__activeStep}
        C'est ce que montre{" "}
        <Typography variant="span" color="#959da2" fontWeight="bold">
          <ShowChartIcon /> la courbe grise
        </Typography>{" "}
        ci-dessous.{" "}
      </Typography>
      <Typography>{props.___activeStep}</Typography>
      <ReglageParametres
        ageDepart={props.ageDepart}
        baseAgeDepart={props.baseAgeDepart}
        handleAgeDepart={props.handleAgeDepart}
        niveauCotisationUtilisateur={props.niveauCotisationUtilisateur}
        baseNiveauCotisation={props.baseNiveauCotisation}
        handleNiveauCotisationUtilisateur={
          props.handleNiveauCotisationUtilisateur
        }
        pensionMoyenne={props.pensionMoyenne}
        basePensionMoyenne={props.basePensionMoyenne}
        handlePensionMoyenne={props.handlePensionMoyenne}
        step={props.activeStep}
      />

      {props.parametresModifies ? (
        <>
          <PhraseCourbeRouge
            step={props.activeStep}
            texteEquilibreFinancier={props.texteEquilibreFinancier}
            texteNiveauVie={props.texteNiveauVie}
            duree2022={props.duree2022}
            duree2070={props.duree2070}
          />
          <Box textAlign="center">
            <Button onClick={props.handleReset} variant="contained">
              Réinitialiser
            </Button>
          </Box>
        </>
      ) : null}
</Box>
      {props.activeStep === 0 ? (
        <ChartSoldeFinancier
          soldeFinancierSansReforme={calculerSoldeTouteAnnee(
            0,
            props.contexteSocioEco,
            1,
            props.niveauCotisationUtilisateur / 100,
            props.ageDepart,
            props.pensionMoyenne,
            props.baseAgeDepart,
            props.baseNiveauCotisation,
            props.basePensionMoyenne
          )}
          soldeFinancierAvecReforme={calculerSoldeTouteAnnee(
            0,
            props.contexteSocioEco,
            0,
            props.niveauCotisationUtilisateur / 100,
            props.ageDepart,
            props.pensionMoyenne,
            props.baseAgeDepart,
            props.baseNiveauCotisation,
            props.basePensionMoyenne
          )}
          parametresModifies={props.parametresModifies}
        />
      ) : props.activeStep === 1 ? (
        <ChartNiveauVie
          soldeFinancierSansReforme={calculerSoldeTouteAnnee(
            1,
            props.contexteSocioEco,
            1,
            props.niveauCotisationUtilisateur / 100,
            props.ageDepart,
            props.pensionMoyenne,
            props.baseAgeDepart,
            props.baseNiveauCotisation,
            props.basePensionMoyenne
          )}
          soldeFinancierAvecReforme={calculerSoldeTouteAnnee(
            1,
            props.contexteSocioEco,
            0,
            props.niveauCotisationUtilisateur / 100,
            props.ageDepart,
            props.pensionMoyenne,
            props.baseAgeDepart,
            props.baseNiveauCotisation,
            props.basePensionMoyenne
          )}
          parametresModifies={props.parametresModifies}
        />
      ) : (
        <ChartTempsRetraite
          soldeFinancierSansReforme={calculerSoldeTouteAnnee(
            2,
            props.contexteSocioEco,
            1,
            props.niveauCotisationUtilisateur / 100,
            props.ageDepart,
            props.pensionMoyenne,
            props.baseAgeDepart,
            props.baseNiveauCotisation,
            props.basePensionMoyenne
          )}
          soldeFinancierAvecReforme={calculerSoldeTouteAnnee(
            2,
            props.contexteSocioEco,
            0,
            props.niveauCotisationUtilisateur / 100,
            props.ageDepart,
            props.pensionMoyenne,
            props.baseAgeDepart,
            props.baseNiveauCotisation,
            props.basePensionMoyenne
          )}
          parametresModifies={props.parametresModifies}
        />
      )}
    </React.Fragment>
  );
}

export default ContenuEtape;
